module.exports = __webpack_public_path__ + "img/chuckle_ios_802.png";